var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},_vm._l((_vm.filters),function({ id, values }){return _c('ElevateFilterOption',{key:id,attrs:{"filter-id":id,"filters":values,"search-request-id":_vm.searchRequestId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }